import {
  AVAILABLE_NIGHTS_PARAM,
  AVAILABLE_WEEKENDS_PARAM,
  FREE_CONSULTATION_PARAM,
  IN_PERSON_PARAM,
} from '../more-filters-boolean-options';
import { PRESELECTION_INPUT_MAPPINGS } from 'client-portal/utils/clinicianSearch/facets/manifest';

export const CLINICIAN_SEARCH_ONLY_QUERY_PARAM_KEYS = [
  'pageNumber',
  'availableDays',
  'availableTimes',
  'cptCodes',
  'name',
  'specialty',
  'insurance',
  'service',
  'ageGroup',
  'globalMonarchChannelId',
  AVAILABLE_NIGHTS_PARAM,
  AVAILABLE_WEEKENDS_PARAM,
  IN_PERSON_PARAM,
  FREE_CONSULTATION_PARAM,
];

export const BOOKING_PRESELECTION_KEYS = [
  'preselected',
  'preselectedOfficeIds',
  'preselectedCptCodeIds',
  'preselectedDays',
  'preselectedTimes',
];

export function clearedBookingPreselectionProperties() {
  return Object.fromEntries(BOOKING_PRESELECTION_KEYS.map(key => [key, null]));
}

export function queryParamsWithClearedKeys(queryParams = {}, keys = []) {
  let next = { ...queryParams };
  for (let key of keys) {
    next[key] = null;
  }
  return next;
}

export function preselectionIdsForQueryParam(queryParams = {}, key) {
  let mapping = PRESELECTION_INPUT_MAPPINGS.find(m => m.to === key);
  if (!mapping) {
    return [];
  }
  return [...new Set(mapping.parse(queryParams?.[key]))];
}

export function bookingPreselectionQueryParamsFromClinicianSearch({
  clinicianId,
  officeIds,
  cptCodes,
  availableDays,
  availableTimes,
  queryParams,
} = {}) {
  let keysToClear = [
    ...BOOKING_PRESELECTION_KEYS.filter(key => key !== 'clinicianId' && key !== 'preselected'),
    'cptCodeId',
  ];
  let next = queryParamsWithClearedKeys(
    queryParamsWithClearedKeys(queryParams, CLINICIAN_SEARCH_ONLY_QUERY_PARAM_KEYS),
    keysToClear
  );

  next.clinicianId = String(clinicianId);
  next.preselected = true;

  let inputs = { officeIds, cptCodes, availableDays, availableTimes };
  for (let { from, to, parse, csv } of PRESELECTION_INPUT_MAPPINGS) {
    let serialized = csv(parse(inputs[from]));
    if (serialized) {
      next[to] = serialized;
    }
  }

  return next;
}
